import { saveAs } from 'file-saver';
import moment from 'moment';
import { combineReducers } from 'redux';

import SubscriptionTypes from './types';

const exportCsv = (actionName: string, initialState: any, request: String, success: String, error: String) => {
  return (state = initialState ? initialState : {}, action: any) => {
    switch (action.type) {
      case request:
        return { ...state, isExporting: true };
      case success:
        const dateExport = moment(new Date()).format('DD-MM-YYYY');
        let fileExport = new Blob([action.payload], { type: 'text/csv; charset=utf-8' });
        saveAs(fileExport, `meus-contratos-${dateExport}.csv`);
        return { ...state, isExporting: false };
      case error:
        return { ...state, isExporting: false };
      default:
        return state;
    }
  };
};

export const subscriptionReducer = combineReducers({
  list: SubscriptionTypes.list.getReducer(),
  invoices: SubscriptionTypes.invoices.getReducer(),
  postback: SubscriptionTypes.postback.getReducer(),
  cancel: SubscriptionTypes.cancel.getReducer(),
  cancelAgend: SubscriptionTypes.cancelAgend.getReducer(),
  suspend: SubscriptionTypes.suspend.getReducer(),
  products: SubscriptionTypes.products.getReducer(),
  status: SubscriptionTypes.status.getReducer(),
  charge: SubscriptionTypes.charge.getReducer(),
  addAffiliate: SubscriptionTypes.addAffiliate.getReducer(),
  setNewDueDate: SubscriptionTypes.setNewDueDate.getReducer(),
  changePayment: SubscriptionTypes.changePayment.getReducer(),
  export: SubscriptionTypes.export.createReducer(exportCsv),
  bankslip: SubscriptionTypes.bankslip.getReducer(),
  changePaymentBankslip: SubscriptionTypes.changePaymentBankslip.getReducer(),
  getContractData: SubscriptionTypes.getContractData.getReducer(),
  changeChargeEmail: SubscriptionTypes.changeChargeEmail.getReducer(),
  getNextToken: SubscriptionTypes.getNextToken.getReducer(),
  saveNegotiateInvoices: SubscriptionTypes.saveNegotiateInvoices.getReducer(),
});
